module.exports = __webpack_public_path__ + "static/media/Hepatocellular.5f023def.webp";